import React from 'react';
import { Card, CardMedia, CardContent, Typography, Chip, Box } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';

const PostCard = ({ post }) => {
  const showMeta = post.showDate || post.showTime;
  const dateText = post.showDate && post.date ? new Date(post.date).toLocaleDateString() : '';
  const timeText = post.showTime && post.time ? post.time : '';

  return (
    <Card
      component={RouterLink}
      to={`/posts/${post.id}`}
      sx={{
        height: '100%',
        textDecoration: 'none',
        color: 'inherit',
        overflow: 'hidden',
        bgcolor: 'background.paper',
        border: '1px solid',
        borderColor: 'divider',
        borderRadius: 2,
        boxShadow: '0px 4px 20px rgba(0, 0, 0, 0.06)',
        '&:hover': {
          transform: 'translateY(-8px)',
          transition: 'all 0.3s ease',
          boxShadow: '0px 20px 40px rgba(0,0,0,0.12)'
        }
      }}
    >
      {post.image ? (
        <CardMedia
          component="img"
          height={280}
          image={post.image}
          alt={post.title}
          sx={{ objectFit: 'cover' }}
        />
      ) : (
        <Box sx={{ height: 280, bgcolor: 'grey.200', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
          <Typography variant="caption" color="text.secondary">No image</Typography>
        </Box>
      )}

      <CardContent sx={{ p: 3 }}>
        <Chip
          label={post.author || 'Announcement'}
          color="primary"
          size="small"
          sx={{ mb: 2, fontWeight: 500, px: 1 }}
        />
        <Typography variant="h5" component="h3" gutterBottom sx={{ fontWeight: 600 }}>
          {post.title}
        </Typography>
        <Typography variant="body1" color="text.secondary" sx={{ lineHeight: 1.6, mb: 2 }}>
          {(post.content || '').substring(0, 140)}...
        </Typography>

        {showMeta && (
          <Typography variant="body2" color="text.secondary">
            {dateText}
            {dateText && timeText ? ' • ' : ''}
            {timeText}
          </Typography>
        )}
      </CardContent>
    </Card>
  );
};

export default PostCard;


